import { render, staticRenderFns } from "./RecCookie.vue?vue&type=template&id=2a1bd800&scoped=true&"
import script from "./RecCookie.vue?vue&type=script&lang=js&"
export * from "./RecCookie.vue?vue&type=script&lang=js&"
import style0 from "./RecCookie.vue?vue&type=style&index=0&id=2a1bd800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1bd800",
  null
  
)

export default component.exports